// extracted by mini-css-extract-plugin
export default {"backNav":"BackButton_backNav__Ht5uo"};